import { BridgeComponent, Message } from '@hotwired/hotwire-native-bridge';

interface NotificationCenterResponseData {
  status: string;
  error: string | undefined;
  deviceId: string;
  deviceName: string;
}

interface NotificationCenterResponseMessage extends Message {
  data: NotificationCenterResponseData;
}

export default class NotificationCenterController extends BridgeComponent {
  public static component = 'notification-center';
  public static targets = ['deviceIdField'];
  declare private readonly hasDeviceIdFieldTarget: boolean;
  declare private readonly deviceIdFieldTarget: HTMLInputElement;

  public connect(): void {
    this.authorize();
  }

  public authorize(): void {
    this.send(
      'authorize',
      {},
      ({ data }: NotificationCenterResponseMessage) => {
        if (this.hasDeviceIdFieldTarget) {
          this.deviceIdFieldTarget.value = data.deviceId;
        }
      }
    );
  }
}
